import { Box, CircularProgress, Typography } from "@mui/material";

export const Loading = ({ message = "Loading..." }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        bgcolor: "background.default",
        gap: 2,
      }}
    >
      <CircularProgress size={48} sx={{ color: "primary.main" }} />
      <Typography variant="body1" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
};
